import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import throttle from "lodash/throttle";

import lazyLoad from "../../../utils/lazy-load";
import { activateOverlayAction } from "../../../services/ui/overlay/actions";
import tracking from "../../../utils/tracking";
import {
  HEADER_COPY,
  IMAGE,
  BODY_COPY,
  CTA_COPY,
  CTA_LINK
} from "../../../utils/content-keys";
import "./article-tabs.scss";

class ArticleTabs extends Component {
  state = { selected: 0, triggerFade: false, updateTo: 0, scrolled: false };
  carouselRef = null;
  throttledScroll = null;

  componentDidMount() {
    this.throttledScroll = throttle(
      () =>
        lazyLoad(
          this.articleRef,
          window.innerHeight + 150,
          this.scrollCallback
        ),
      200
    );
    window.addEventListener("scroll", this.throttledScroll);
  }

  scrollCallback = () => {
    if (this.state.visible) {
      return;
    }

    this.articleRef.src = this.articleRef.getAttribute("data-src");
    this.setState({ scrolled: true });
    window.removeEventListener("scroll", this.throttledScroll);
  };

  parseLinks(input) {
    // cms horizon links are actual asset links so parse the markdown
    input = input.replace(
        /\[([^\]]+)]\(https:\/\/cms.diageohorizon.com\/([^\)]+)\)/g,
        '<a href="https://cms.diageohorizon.com/$2" class="ArticleTabs__content-copy--link" target="_blank">$1</a>'
    );

    return input.replace(
      /\[([^\]]+)]\(([^\)]+)\)/g,
      '<a href="#" class="ArticleTabs__content-copy--link" data-link="overlay">$1</a>'
    );
  }

  fadeOut = index => {
    this.setState({ triggerFade: true, updateTo: index });
  };

  onTransitionEnd = () => {
    if (!this.state.triggerFade) {
      return;
    }

    this.setState(state => {
      state.triggerFade = false;
      state.selected = state.updateTo;
      return state;
    });
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.throttledScroll);
  }

  onClick = evt => {
    if (evt.target.getAttribute("data-link") === "overlay") {
      evt.preventDefault();

      const { activateOverlayAction, overlayId } = this.props;

      tracking.event("customEvent", {
        eventCategory: "Private Functions",
        eventAction: "click",
        eventLabel: "Visit the Taproom - Accessibility"
      });

      tracking.pageView("/contact");
      tracking.event("formShown", { formName: "contact" });
      activateOverlayAction(overlayId);
    }
  };

  // render() {
  //   const { content, infoCta } = this.props;
  //   const { selected } = this.state;

  //   if (!content) {
  //     return null;
  //   }

  //   return (
  //     <div className="container-fluid ArticleTabs">
  //       <div className="row ">
  //         <div className="col-sm-12">
  //           <h3 className="ArticleTabs__title">HELP & INFORMATION</h3>
  //         </div>
  //       </div>
  //       <div className="row">
  //         <div className="col-sm-12 ArticleTabs__navigation">
  //           {content.map((item, index) => (
  //             <div className="ArticleTabs__navigation-item">
  //               <a
  //                 className={`ArticleTabs__navigation-item-title ${
  //                   this.state.selected === index
  //                     ? "ArticleTabs__navigation-item-title--selected"
  //                     : ""
  //                 }`}
  //                 onClick={() => {
  //                   tracking.event("customEvent", {
  //                     eventCategory: "Help & Information",
  //                     eventAction: "click",
  //                     eventLabel: content[index][HEADER_COPY].value
  //                   });
  //                   this.fadeOut(index);
  //                 }}
  //               >
  //                 {item[HEADER_COPY].value}
  //               </a>
  //             </div>
  //           ))}
  //         </div>
  //       </div>

  //       {content && (
  //         <div
  //           className={`row ArticleTabs__content ${
  //             this.state.triggerFade ? "ArticleTabs__content--fade" : ""
  //           }`}
  //           onTransitionEnd={this.onTransitionEnd}
  //         >
  //           <Link
  //             className="cta cta--lg-font ArticleTabs__cta d-sm-none"
  //             to={infoCta[CTA_LINK].value}
  //             onClick={() =>
  //               tracking.event("customEvent", {
  //                 eventCategory: "Help & Information",
  //                 eventAction: "click",
  //                 eventLabel: "FAQs"
  //               })
  //             }
  //           >
  //             {infoCta[CTA_COPY].value}
  //           </Link>
  //           <div className="col-md-6">
  //             <img
  //               src={
  //                 this.state.scrolled ? content[selected][IMAGE].length?content[selected][IMAGE][0].imgURL:content[selected][IMAGE].imgURL : null
  //               }
  //               srcset={
  //                 this.state.scrolled ?  content[selected][IMAGE].length ? `${content[selected][IMAGE][1].imgURL} 750w, ${
  //                   content[selected][IMAGE][0].imgURL
  //                 } 1984w` : content[selected][IMAGE].imgURL: null
  //               }
  //               data-src={
  //                 this.state.scrolled ? null : content[selected][IMAGE].length ? content[selected][IMAGE][0].imgURL : content[selected][IMAGE].imgURL
  //               }
  //               className="ArticleTabs__image"
  //               ref={el => {
  //                 if (!this.articleRef && el) {
  //                   this.articleRef = el;
  //                 }
  //               }}
  //               alt=""
  //             />
  //           </div>
  //           <div className="col-md-6 ArticleTabs__copy-wrapper">
  //             <p
  //               className="ArticleTabs__content-copy"
  //               dangerouslySetInnerHTML={{
  //                 __html: this.parseLinks(content[selected][BODY_COPY].value)
  //               }}
  //               onClick={this.onClick}
  //             />
  //             <Link
  //               className="cta cta--lg-font ArticleTabs__cta d-none d-sm-block"
  //               to={infoCta[CTA_LINK].value}
  //               onClick={() =>
  //                 tracking.event("customEvent", {
  //                   eventCategory: "Help & Information",
  //                   eventAction: "click",
  //                   eventLabel: "FAQs"
  //                 })
  //               }
  //             >
  //               {infoCta[CTA_COPY].value}
  //             </Link>
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   );
  // }
}

export default connect(
  state => ({}),
  { activateOverlayAction }
)(ArticleTabs);



// WEBPACK FOOTER //
// ./src/pages/visitus/ArticleTabs/index.js